<template>
  <Transition name="t--transition" appear @after-leave="afterTransitionEnds">
    <div class="t-modal" :class="classes">
      <div class="t-modal__dialog">
        <div v-on-mousedownaway="onMousedownAway" class="t-modal__content">
          <slot />
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock';
import { mixin as mousedownaway } from '../../directives/mousedownaway';
import { checkClassWhitelistOnClick } from '../../utils';

const ClassName = {
  OPEN: 't-modal-open',
};

let modalCount = 0;

export default {
  name: 't-modal',

  mixins: [mousedownaway],

  props: {
    classWhitelist: {
      type: [Array, String],
      default: '',
    },

    requireExplicitClose: {
      type: Boolean,
      default: false,
    },

    size: {
      type: String,
      required: false,
      default: 'md',
    },

    hijackBack: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    classes() {
      const classes = [];

      if (this.size) {
        classes.push(`t-modal--${this.size}`);
      }

      return classes;
    },
  },

  mounted() {
    if (this.hijackBack && this.$router) {
      // Handle back.
      const unregisterRouterGuard = this.$router.beforeEach(
        (_to, _from, next) => {
          this.back();

          next(false);
        },
      );

      this.$once('hook:destroyed', () => {
        unregisterRouterGuard();
      });
    }

    document.addEventListener('keydown', this.handleEscape);

    if (modalCount === 0) {
      document.body.classList.add(ClassName.OPEN);
    }

    disableBodyScroll(this.$el, {
      reserveScrollBarGap: true,
    });

    modalCount += 1;
  },

  beforeDestroy() {
    enableBodyScroll(this.$el);
  },

  destroyed() {
    document.removeEventListener('keydown', this.handleEscape);
    modalCount -= 1;
  },

  methods: {
    handleEscape(e) {
      if (!this.requireExplicitClose) {
        e.stopPropagation();

        if (e.keyCode === 27) {
          this.close();
        }
      }
    },

    close(e) {
      if (e && checkClassWhitelistOnClick(e, this.classWhitelist)) {
        return;
      }

      this.$emit('modal-close', e);
    },

    afterTransitionEnds() {
      if (modalCount === 0) {
        document.body.classList.remove(ClassName.OPEN);
      }
    },

    onMousedownAway(e) {
      if (this.requireExplicitClose) {
        return;
      }

      this.close(e);
    },
  },
};
</script>
